import { Box, Typography } from "@mui/material";

export function StepperCountBox({ stepperCount, text }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "6px"
      }}
    >
      <Typography variant="h6" component="div" color="#1976d2" fontSize="16px">
        Step
      </Typography>
      <Box
        sx={{
          width: 35,
          height: 35,
          bgcolor: "#1976d2",
          borderRadius: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 24,
          fontWeight: "bold",
          color: "white",
          textAlign: "center"
        }}
      >
        {stepperCount}
      </Box>
      <Typography
        variant="h6"
        component="div"
        textAlign="center"
        fontSize="16px"
      >
        {text}
      </Typography>
    </Box>
  );
}
